export default __webpack_public_path__ + "static/media/t1.75eb3135.jpg";